
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { HandleErrorsService } from './handle-errors.service';

@Injectable({
    providedIn: 'root'
})
export class FetchService {

    constructor(private http: HttpClient, public handleErrors: HandleErrorsService) {}

    /**
     * Ejecuta la petición con HttpClient preservando el contrato del antiguo
     * fetch() + handleResponse:
     *  - 2xx                     -> resuelve con el body (JSON).
     *  - error HTTP (status > 0) -> resuelve con el objeto de error (NO lanza),
     *                               que servicios/componentes leen en su `.then()`.
     *  - error de red/CORS (0)   -> re-lanza (rechaza), como hacía fetch().
     */
    private request(obs: any): Promise<any> {
        return firstValueFrom(obs).catch((err: any) => {
            if (err instanceof HttpErrorResponse && err.status > 0) {
                return this.handleErrors.handleHttpError(err);
            }
            throw err;
        });
    }

    get(url) {
        return this.request(this.http.get(url));
    }

    post(url, data) {
        return this.request(this.http.post(url, data));
    }

    put(url, data) {
        return this.request(this.http.put(url, data));
    }

    // Envío de ficheros (FormData): HttpClient NO fija Content-Type y deja que el
    // navegador ponga el boundary multipart. Es funcionalmente igual que post();
    // se mantiene aparte por legibilidad en los call-sites de subida.
    postFile(url, data) {
        return this.request(this.http.post(url, data));
    }
}
